import React from "react";
import { BaseSvgIcon, createIcon } from "../IconBase";
// GENERATED from custom/src/auto_approved.svg by scripts/generate-icons.mjs. Do not edit
// by hand — edit the source SVG and regenerate.
const AutoApprovedIconGlyph = (props) => (React.createElement(BaseSvgIcon, { ...props },
    React.createElement("path", { d: "M6 12.5l4 4 8-9", fill: "none", stroke: "currentColor", strokeWidth: "2.6", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("text", { x: "19.5", y: "16", textAnchor: "middle", dominantBaseline: "central", fontSize: "12", fontWeight: "700", fill: "currentColor" }, "A")));
export const AutoApprovedIcon = createIcon(AutoApprovedIconGlyph, "AutoApprovedIcon", "0 0 24 24");
//# sourceMappingURL=AutoApprovedIcon.js.map